/* eslint-disable no-restricted-globals */
import moment from "moment";
import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import { VscHistory } from "react-icons/vsc";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import PaymentsLogModel from "../jobs/PaymentsLogModel";

const TaskResults = ({ list }) => {
  const PLog = PaymentsLogModel();
  const [model, setModel] = useState({});

  return (
    <div>
      <table className="table table-default">
        <thead>
          <tr>
            <th>Task ID </th>
            <th>Client</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list?.map((inv) => {
            // const po = inv.po[inv.po.length - 1];
            return (
              <tr key={inv._id}>
                <td style={{ minWidth: 150 }}>{inv.taskId}</td>
                <td>{inv.organization?.name}</td>
                <td>{inv.startTime}</td>
                <td>{inv.endTime}</td>
                <td>{inv.status}</td>
                <td>
                  <div
                    className="side-button"
                    style={{ width: 70, borderWidth: 1, display: "flex" }}
                  ></div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TaskResults;
